export default "__VITE_ASSET__ThMjbvTa__"